import React from 'react';
import { Switch, Route } from 'react-router-dom';

import LandingPage from '../../../views/landing';
import HomePage from '../../../views/home';
import AuthPage from '../../../views/auth';
import WriteAnswers from '../../../views/write-answers';
import QuestionDetail from '../../../views/question-detail';
import AnswerDetail from '../../../views/answer-detail';
import TopicPage from '../../../views/topic';
import ProfilePage from '../../../views/profile';
import StatsPage from '../../../views/stats';
import NotFoundPage from '../../../views/not-found';

// Authorization HOCs
// import requireAuth from "../../../hoc/req-auth";
import noAuthRequired from '../../../hoc/no-auth';

function Main() {
  return (
    <main className="main" role="main">
      <Switch>
        <Route exact path="/" component={noAuthRequired(LandingPage)} />
        <Route path="/home" component={HomePage} />
        <Route path="/auth" component={noAuthRequired(AuthPage)} />
        <Route path="/answer" component={WriteAnswers} />
        <Route
          exact
          path="/question/:questionTitle"
          component={QuestionDetail}
        />
        <Route
          path="/question/:questionId/:userName"
          component={AnswerDetail}
        />
        <Route path="/topic/:topicName" component={TopicPage} />
        <Route path="/account/:fullname/stats" component={StatsPage} />
        <Route path="/account/:fullname" component={ProfilePage} />
        <Route component={NotFoundPage} />
      </Switch>
    </main>
  );
}

export default Main;
